module.exports = __webpack_public_path__ + "static/img/cargo-content-2.025a337.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cargo-content-2.png
// module id = fvij
// module chunks = 0